module.exports = __webpack_public_path__ + "static/media/multisplit.2186857d.png";